import { server } from './config'
import client from './client'

export default {
  getQuestions(data = {}, config = {}) {
    return client.get(`${server}/checkin/api/questions?language=${data}`)
  }
}
